import { render, staticRenderFns } from "./FilterColors.vue?vue&type=template&id=7d7a011d&"
import script from "./FilterColors.vue?vue&type=script&lang=js&"
export * from "./FilterColors.vue?vue&type=script&lang=js&"
import style0 from "./FilterColors.vue?vue&type=style&index=0&id=7d7a011d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports